import PropTypes from 'prop-types';
import Address from './address';

export default PropTypes.shape({
  uuid: PropTypes.string,
  name: PropTypes.string,
  address: Address
});


// WEBPACK FOOTER //
// ./src/shapes/customer.js